import LazyLoad from 'vanilla-lazyload'

import 'assets/lib/newsletter_subscription.js'

new LazyLoad({ elements_selector: '.lazy' })
